<template>
  <TableBox :current-page="currentPage" :meta="meta" @onChangePage="$emit('onChangePage', $event)">
    <b-table
      sticky-header
      id="my-table"
      :fields="fields"
      :items="list"
      :busy="isLoading"
      class="custom-table"
      thead-class="custom-table-header"
      tbody-tr-class="custom-table-body"
      :emptyText="$t('text.emptyText')"
      show-empty
    >
      <template #cell(index)="data">
        {{ data.index + 1 }}
      </template>

      <template #cell(name)="data">
        <p style="width: 360px">{{ data.item.name }}</p>
      </template>

      <template #cell(status)="data">
        <Status :value="data.item.isActive" />
      </template>

      <template #cell(publishedAt)="data">
        <p class="text-nowrap">{{ data.item.publishedAt }}</p>
      </template>

      <template #cell(action)="data">
        <div class="table-action-buttons">
          <InlineButton
            variant="outline-secondary"
            size="sm"
            pill
            @click="$emit('edit', data.item.id)"
            class="has-shadow"
          >
            {{ $t('text.editButton') }}
          </InlineButton>
          <InlineButton
            variant="outline-danger"
            size="sm"
            pill
            @click="$emit('remove', data.item.id)"
            class="has-shadow"
          >
            {{ $t('text.deleteButton') }}
          </InlineButton>
        </div>
      </template>
    </b-table>
  </TableBox>
</template>

<script>
import TableBox from '@/components/ui/TableBox';
import Status from '@/components/ui/Status';
import InlineButton from '@/components/ui/button/InlineButton';

export default {
  props: {
    list: Array,
    meta: Object,
    currentPage: Number,
    isLoading: Boolean,
  },

  data() {
    return {
      fields: [
        {
          key: 'index',
          label: '#',
        },
        {
          key: 'name',
          label: this.$t('table.th.name'),
        },
        {
          key: 'status',
          label: this.$t('table.th.status'),
        },
        {
          key: 'isTrend',
          label: this.$t('table.th.isTrend'),
        },
        {
          key: 'publishedAt',
          label: this.$t('table.th.publishedAt'),
        },
        {
          key: 'action',
          label: this.$t('table.th.settings'),
        },
      ],
    };
  },

  components: {
    TableBox,
    Status,
    InlineButton,
  },
};
</script>
